import React from 'react';
import { Box } from '@mui/material';
import ProductListItem from './ProductListItem';

function ProductList({ results }) {
  if (!results || results.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #ddd',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      {results.map((result, idx) => (
        <ProductListItem
          key={`${result.normalized_key}-${idx}`}
          result={result}
          index={idx}
          totalResults={results.length}
        />
      ))}
    </Box>
  );
}

export default ProductList;
